// ============================================================
// RB-PMS v3 — Quotation Template Service
// File: src/services/quotationTemplate.service.ts
// ============================================================

import api from '../utils/api';

export interface QuotationField {
  field_key: string;
  label: string;
  field_type: 'text' | 'number' | 'date' | 'textarea';
}

export interface QuotationTemplate {
  template_id: number;
  template_name: string;
  fields: QuotationField[];
  image_data?: string;
  image_mime_type?: string;
  created_at: string;
  updated_at?: string;
}

export interface QuotationEntry {
  entry_id: number;
  template_id: number;
  entry_name: string | null;
  field_values: Record<string, string>;
  created_at: string;
}

export const quotationTemplateService = {
  // Upload an image, get AI-extracted fields back. Does NOT save yet.
  extractFields: (imageFile: File) => {
    const formData = new FormData();
    formData.append('image', imageFile);
    return api.post('/quotation-template/extract', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  saveTemplate: (payload: {
    template_name: string;
    image_data: string;
    image_mime_type: string;
    fields: QuotationField[];
  }) => api.post('/quotation-template', payload),

  getAll: () => api.get('/quotation-template'),
  getById: (id: number) => api.get(`/quotation-template/${id}`),
  delete: (id: number) => api.delete(`/quotation-template/${id}`),

  createEntry: (templateId: number, entryName: string, fieldValues: Record<string, string>) =>
    api.post(`/quotation-template/${templateId}/entries`, { entry_name: entryName, field_values: fieldValues }),

  getEntriesByTemplate: (templateId: number) =>
    api.get(`/quotation-template/${templateId}/entries`),

  getEntryById: (id: number) => api.get(`/quotation-template/entries/${id}`),

  updateEntry: (id: number, fieldValues: Record<string, string>) =>
    api.put(`/quotation-template/entries/${id}`, { field_values: fieldValues }),

  // Returns a Blob — caller creates a download link from it.
  downloadEntryPdf: (entryId: number) =>
    api.get(`/quotation-template/entries/${entryId}/pdf`, { responseType: 'blob' }),
};
